<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded"
      title="Telco"
      :description="`Telecommunications`"
      action="Save"
      :hidecancel="true"
      @handle-action="updateTeam"
    >
      <ToggleInput
        label="Bulk Messaging Enabled"
        description="Allows a Customer to send bulk text messages to their team. Please ensure that the Customer knows they can only bulk message their team and they are not to use the functionality to potentially bulk message Candidates that haven't opted in."
        :model-value="team.bulkMessagingEnabled"
        @update:model-value="team.bulkMessagingEnabled = $event"
      />
    </DetailForm>
    <DetailForm
      v-if="loaded"
      class="mt-6"
      title="10DLC Registration"
      description="10DLC numbers are local long-code numbers that are approved by mobile network operators for A2P SMS messaging. This approval comes about by registering the local long-code number with a verified 10DLC brand and an approved 10DLC campaign."
      :hidecancel="true"
      action="Save"
      @handle-action="updateRegistration"
    >
      <div class="grid grid-cols-2 gap-x-2 gap-y-4">
        <TextInput
          class="col-span-1"
          label="Legal Contact Name"
          placeholder="Chris Giannos"
          :model-value="team.legalContactName"
          @update:model-value="value => (team.legalContactName = value)"
        />
        <TextInput
          class="col-span-1"
          label="Legal Contact Title"
          placeholder="CEO"
          :model-value="team.legalContactTitle"
          @update:model-value="value => (team.legalContactTitle = value)"
        />
      </div>
      <div class="grid grid-cols-2 gap-x-2 gap-y-4">
        <TextInput
          class="col-span-1"
          label="Legal Contact Email"
          placeholder="support@humaniz.io"
          :model-value="team.legalContactEmail"
          @update:model-value="value => (team.legalContactEmail = value)"
        />
        <PhoneInput
          class="col-span-1"
          label="Legal Contact Phone"
          placeholder="+1 (281) 330 8004"
          :model-value="team.legalContactPhone"
          @update:model-value="team.legalContactPhone = $event"
        />
        <TextInput
          class="col-span-2"
          label="Legal Company Name"
          placeholder="Humaniz, LLC"
          :model-value="team.legalCompanyName"
          @update:model-value="value => (team.legalCompanyName = value)"
        />
        <TextInput
          class="col-span-1"
          label="Website"
          placeholder="www.humaniz.io"
          :model-value="team.website"
          @update:model-value="value => (team.website = value)"
        />
        <TextInput
          class="col-span-1"
          label="EIN Number"
          placeholder="12-3456789"
          :model-value="team.einNumber"
          @update:model-value="value => (team.einNumber = value)"
        />
      </div>

      <div class="border-t border-gray-200 pt-5 grid grid-cols-2 gap-x-2 gap-y-4">
        <TextInput
          class="col-span-2"
          label="Street Address"
          placeholder="2942 Century Pl"
          :model-value="team.legalStreetAddress"
          @update:model-value="value => (team.legalStreetAddress = value)"
        />
        <TextInput
          class="col-span-1"
          label="City"
          placeholder="Costa Mesa"
          :model-value="team.legalCity"
          @update:model-value="value => (team.legalCity = value)"
        />
        <TextInput
          class="col-span-1"
          label="State"
          placeholder="CA"
          :model-value="team.legalState"
          @update:model-value="value => (team.legalState = value)"
        />
        <TextInput
          class="col-span-1"
          label="Country"
          placeholder="United States"
          :model-value="team.legalCountry"
          @update:model-value="value => (team.legalCountry = value)"
        />
        <TextInput
          class="col-span-1"
          label="Zip/Postal Code"
          placeholder="92626"
          :model-value="team.legalPostalCode"
          @update:model-value="value => (team.legalPostalCode = value)"
        />
      </div>
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      team: {
        id: '',
        legalContactName: '',
        legalContactTitle: '',
        legalContactEmail: '',
        legalContactPhone: '',
        legalCompanyName: '',
        website: '',
        einNumber: '',
        legalStreetAddress: '',
        legalCity: '',
        legalState: '',
        legalCountry: '',
        legalPostalCode: '',
        bulkMessagingEnabled: false,
      },
      smsConfiguration: {
        provider: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch('/api/team')
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.legalContactName = data.record.legal_contact_name;
          self.team.legalContactTitle = data.record.legal_contact_title;
          self.team.legalContactEmail = data.record.legal_contact_email;
          self.team.legalContactPhone = data.record.legal_contact_phone_number;
          self.team.legalCompanyName = data.record.legal_company_name;
          self.team.website = data.record.website;
          self.team.einNumber = data.record.ein_number;
          self.team.legalStreetAddress = data.record.legal_street;
          self.team.legalCity = data.record.legal_city;
          self.team.legalState = data.record.legal_state;
          self.team.legalCountry = data.record.legal_country;
          self.team.legalPostalCode = data.record.legal_postal_code;
          self.team.bulkMessagingEnabled = data.record.bulk_messaging_enabled;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/team', {
        method: 'PUT',
        body: JSON.stringify({
          bulk_messaging_enabled: self.team.bulkMessagingEnabled,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('Bulk messaging updated', {
              action: { label: 'Dismiss' },
              description:
                'Your bulk messaging settings were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Bulk messaging update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
    updateRegistration() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/team', {
        method: 'PUT',
        body: JSON.stringify({
          legal_contact_name: self.team.legalContactName,
          legal_contact_title: self.team.legalContactTitle,
          legal_contact_email: self.team.legalContactEmail,
          legal_contact_phone_number: self.team.legalContactPhone,
          legal_company_name: self.team.legalCompanyName,
          website: self.team.website,
          ein_number: self.team.einNumber,
          legal_street: self.team.legalStreetAddress,
          legal_city: self.team.legalCity,
          legal_state: self.team.legalState,
          legal_country: self.team.legalCountry,
          legal_postal_code: self.team.legalPostalCode,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('10DLC registration updated', {
              action: { label: 'Dismiss' },
              description:
                'Your 10DLC registration details were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('10DLC registration update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
